const { useMemo } = require('react');

export function useURLQueryParams(history) {
  const { search } = history.location;
  return useMemo(() => new URLSearchParams(search), [search]);
}
